import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import Product2 from "../components/Product2";
import { BsCameraFill, BsImages, BsXLg } from "react-icons/bs";
import { Link , useLocation ,useParams } from "react-router-dom";
import { useAxios } from "../services/useAxios";
import {alert, confirm} from "../components/MegConfirmAlert";
import { useTranslation } from 'react-i18next';
import { useForm } from "react-hook-form";

export default function ReviewWrite() {
    const { t } = useTranslation();
    const [data, setData] = useState({});
    let {id} = useParams();
    const [request] = useAxios();
    const [imgList, setImgList] = useState([]);
    const [rating, setRating] = useState(0);
    const [fileData, setFileData] = useState([]);
    const fileInput1 = React.createRef();
    const fileInput2 = React.createRef();
    const {register, handleSubmit, setValue,  reset, formState, clearErrors }= useForm();
    const{errors} = formState;  

    const fetchData = async () => {
       
        const response = await request.post("/app/mypage/getMyOrderReviewGoodsInfoAPI", {
            orderDetailSn: id
        });

        if(response.data.resultCode === 200){

            if(!response.data.result.orderReviewGoodsInfo){
                await alert(t(`Message.my_goods_review_target_list_empty`));
                window.location.href="/MyPage";
            }
            console.log(response.data.result);    
            setData(response.data.result);          
                  
        }
    };

    const fn_fileSel = (e) =>{
       
        let fileArr = e.target.files;    
       
        for(let i = 0; i < fileArr.length; i++){    
            setFileData(prev => [...prev, fileArr[i]])       
            const reader = new FileReader();
            reader.readAsDataURL(fileArr[i]);
            reader.onload = function(){
                setImgList(prev => [...prev, reader.result])
                              
            }
        };
    }


    const fn_fileRemove = (index) => {        
        setImgList(imgList.filter((_,objIndex) => objIndex !== index))
        setFileData(fileData.filter((_,objIndex) => objIndex !== index))        
    } 
    
    const onSubmit = async dataInfo=> {
        let formData = new FormData();
        fileData.forEach(function (value, index) {
            formData.append("files", value);
        });
        formData.append("orderSn", data.orderReviewGoodsInfo.orderSn);
        formData.append("aditfield1", data.orderReviewGoodsInfo.goodsSn);
        formData.append("aditfield2", data.orderReviewGoodsInfo.orderDetailSn);
        formData.append("aditfield3", dataInfo.aditfield3);
        formData.append("nttCn", dataInfo.nttCn);
        
        const response = await request.post("/app/mypage/procMyOrderReviewRegistAPI",formData,{
            headers: {'Content-Type': 'multipart/form-data', charset: 'utf-8'}
        });            
        console.log(response.data)
        if(response.data.resultCode === 200){
            await alert(response.data.resultMessage);
            window.location.href="/MyPage";

        }else{
            alert(response.data.resultMessage);
        }  
    }

    useEffect(() => {
        fetchData();        
      }, []);
    return (
        <div>
            <Header type="black" pageTitle={t(`Message.my_goods_review_regist_title`)}/>
            {!data.orderReviewGoodsInfo  ? null :(
            <div className="reviewWriteWr">
                <Product2 
                    type="type6"
                    img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+data.orderReviewGoodsInfo?.goodsImageSn}
                    prodName={data?.orderReviewGoodsInfo.goodsNm}
                    option1={data.orderReviewGoodsInfo?.firstOptnNm+ " "+ data.orderReviewGoodsInfo?.firstOptnValue + " X "+  data.orderReviewGoodsInfo?.orderQy}                    
                    disprice={"￦"+(!data.orderReviewGoodsInfo?.orderAmount?0:data.orderReviewGoodsInfo?.orderAmount).toLocaleString('ko-KR')}
                />
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="rwCont dfColG8">
                        <div className="dfColG4">
                            <p className="tit">{t(`Message.my_goods_review_star_rating_msg1`)}</p>
                            <p className="cDisa fs13">{t(`Message.my_goods_review_star_rating_msg2`)}</p>
                        </div>
                        <div className="starRate dfccG6">
                            <input type="radio" name="rating" id="rating5" value="5" {...register("aditfield3", { required:"필수 응답 항목입니다."})}   /><label htmlFor="rating5">5점</label>
                            <input type="radio" name="rating" id="rating4" value="4" {...register("aditfield3", { required:"필수 응답 항목입니다."})} /><label htmlFor="rating4">4점</label>
                            <input type="radio" name="rating" id="rating3" value="3" {...register("aditfield3", { required:"필수 응답 항목입니다."})} /><label htmlFor="rating3">3점</label>
                            <input type="radio" name="rating" id="rating2" value="2" {...register("aditfield3", { required:"필수 응답 항목입니다."})} /><label htmlFor="rating2">2점</label>
                            <input type="radio" name="rating" id="rating1" value="1" {...register("aditfield3", { required:"필수 응답 항목입니다."})} /><label htmlFor="rating1">1점</label>                            
                        </div>
                        {errors.aditfield3 && <p role="alert" className="alertRed">{errors.aditfield3.message}</p>}
                    </div>

                    <div className="rwCont dfColG16">
                        <div className="dfColG4">
                            <p className="tit">{t(`Message.my_goods_review_regist_msg1`)}</p>
                            <p className="cDisa fs13">{t(`Message.my_goods_review_regist_msg2`)}</p>
                        </div>
                        <textarea {...register("nttCn", { })} placeholder={t(`Message.my_goods_review_regist_hint_cn`)} className="bde"></textarea>
                        <div className="dfceG8">
                            <button type="button" className="btn40 greenB cFFF" onClick={(e)=> fileInput1.current.click() }><BsCameraFill className="fs16"/> {t(`Message.my_goods_review_regist_take_picture`)}</button>
                            <button type="button" className="btn40 bdd" onClick={(e)=> fileInput2.current.click() }><BsImages /> {t(`Message.my_goods_review_regist_select_picture`)}</button>
                            <input type="file" accept="image/*" onChange={fn_fileSel} capture="environment" ref={fileInput1} style={{ display: "none" }} />
                            <input type="file" accept="image/*" onChange={fn_fileSel} ref={fileInput2} style={{ display: "none" }} />
                        </div>
                        <ul className="thumWr">
                            {imgList && imgList.map((obj, index) => (  
                            <li key={index} >
                                <img src={obj} alt={"img"+index} />
                                <button type="button" className="delBtn" onClick={(e)=>fn_fileRemove(index)}><BsXLg /></button>
                            </li>
                            ))}                       
                        </ul>
                    </div>

                    <div className="ment">
                        <p>{t(`Message.my_goods_review_regist_warn_msg1`)}</p>
                        <p>{t(`Message.my_goods_review_regist_picture_limit`)}</p>
                        <p>{t(`Message.my_goods_review_regist_warn_msg2`)}</p>
                    </div>

                    <button type="submit" className="btn48 orgB cFFF mt30">{t(`Message.saveBtn`)}</button>
                </form>
            </div>
            )}
        </div>
    );
};
